export var BaseEnum;
(function (BaseEnum) {
    BaseEnum[BaseEnum["FIRST"] = 1] = "FIRST";
    BaseEnum[BaseEnum["SECOND"] = 2] = "SECOND";
    BaseEnum[BaseEnum["THIRD"] = 3] = "THIRD";
})(BaseEnum || (BaseEnum = {}));
